export class Product {
    ProductId : number;
    ProductName:string;
    ProductShortDescription:string;
    ProductLongDescription:string;
    Notes:string;
    VendorName:string;
    ProductType:string;
    FoodType:string;
    BrandName:string;
    Picture:string;
    SizeList:SizeList[]
    ProductMappingList : ProductMappingList[];
    DescriptionList:ProductDescriptionList[];
    PictureList:string[];
    VendorId:number;
}
export class SizeList{
    SizeId:number;
    SizeCode:string;
}
export class PagingList{
    RecordPerPage:number;
    CurrentPage:number;
    TotalRecord:number;
    TotalPage:number;
    ProductList : Product[]
}
export class ProductDescriptionList{
    ProdHeader:string;
    ProdDescr:string
}
export class ProductMappingList{
    ProductMappingId:number;
    ProductUnitId: number;
    ProductUnitName: string;
    Product_Min_Quantity:number;
    Product_Max_Quantity:number;
    ProductQuantityDescription:string;
    CustomerPrice:number;
    MarketPrice:number;
}
export class MyCartList{
    ProductMappingId:number;
    ProductName:string;
    ProductUnitId:number;
    ProductMinQuantity:number;
    ProductQuantityDescription:string;
    ProductPrice:number;
    ProductQuantity:number;
    ProductTotalAmount:number;
    ProductId:number;
    Picture1:string;
    VendorId:number;
    VendorName:string;
}
export class LoginInfo{
    CustomerName : string;
    Token: string;
    TokenExpiry:string;
    LocationId:number;
    LocationName:string;
    UserId:number
}
export class UserInfo{
    UserId : number;
    UserName: string;
    UserDeliveryInfo:UserDeliveryInfo;
}
export class User{
    LocationId:number;
    LocationName:string;
    CustomerId:number;
    CustomerName:string;
    Email:string;
    Password:string;
    PostalCode:string;
    Contact:string;
    LocationDetails :LocationList[];
}
export class LocationList{
    locationId: number;
    locationName:string;
}
export class SubCategoryList{
    subCategoryId:number;
    subCategoryName:string;
    imagePath:string;
}
export class CategoryList{
    categoryId:number;
    categoryName:string;
    imagePath:string;
    subCategoryList: SubCategoryList[];
}
export class ApplicationInfo{
    pathLargeImageUrl:string;
    pathSmallImageUrl:string;
    pathMediumImageUrl:string;
    pathThumbnailImageUrl:string;
    cartStorageName:string;
    minimumOrderAmount:number;
    fileBasePath:string;
    apiBasePath:string;
    offerTitle:string;
    loginStorageName:string;
    currentAppVersion:number;
    googlePackageName:string;
}
export class PaymentMethod{
    methodId:number;
    methodName:string;
}
export class BrandList{
    brandId:number;
    brandName:string;
}
export class ProductTypelist{
    productTypeId:number;
    productTypeName:string;
}
export class UserDeliveryInfo{
    PhoneNumber: string;
    Address:string;
    EmailId:string;
}
export class BannerProductTypeVM{
    bannerImageList:string[];
    productTypeList:ProductTypelist[];
    applicationInfo:ApplicationInfo;
}
export class URLInfo{
    urlGetProductForApp:string;
    urlGetOrderHistory:string;
    urlGetProfileDetails:string;
    urlUpdateProfileDetails:string;
    urlPlaceOrder:string;
    urlGetToken :string;
    urlRegisterUser:string;
    urlLogout:string;
    urlContactUs :string;
    urlGetOfferList:string;
    urlGetOrderDetails:string;
    urlCancelOrder:string;
    urlDeleteOrderDetails:string;
    urlCheckOut:string;
    urlLastShippingAddress:string;
    urlAutocomplete:string;
    urlGetBannerList:string;
    urlGetProductDetails:string;
    urlGetAboutUs:string;
    urlGetLocationList:string;
    urlGetFilterType:string;
    urlAddFMCToken:string;
    urlGetProductForAppv2:string;
    urlGetProductUnitForAppv2:string;
    urlGetProductUnitMappingForAppv2:string;
    urlGetProductUnitAmountForAppv2:string;
    urlGetProductDetailsv2:string;
    urlUpdateLocation:string;
    urlWallet:string;

}
export class ConfigInfo{
    applicationInfo: ApplicationInfo;
    urlInfo:URLInfo;
}
export interface PageInterface{
    title :string;
    pageName :string;
    tabComponent :string;
    index?:number;
    icon:string;
  }
  export class RegisterViewModel{
    CustomerName:string;
    PhoneNumber:string;
    Email:string;
    Password:string;
    LocationId:number;
    RefContactNumber:string;
   }
   export class ContactViewModel{
    ContactName:string;
    Mobile:string;
    Email:string;
    Messgae:string;
   }
   export class ProfileViewModel{
    CustomerName:string;
    PhoneNumber:string;
    Email:string;
    Password:string;
    PostalCode:string;
    LocationId:number;
   }
   export class Order{
    OrderId:number;
    OrderDate:string;
    TotalAmount:string;
    Notes:string;
    SupplierName:string;
    ContactNumber:string;
    OrderNumber:string;
    DeliveryChargeAmount:number;

   }
   export class OrderDet{
    OrderId:number;
    OrderDate:string;
    OrderStatus:number;
    DeliverDate:string;
    OrderAmount:number;
    OrderAddress:string;
    CanCellable:boolean;
    OrderNumber:string;
    OrderDiscount:string;
    OrderList:OrderDetails[]
   }
   export class OrderDetails{
    OrderDetailsId:number;
    ProductName:string;
    ProductUnit:string;
    Quantity:number;
    PerUnitPrice:number;
    TotalAmount:number;
    IsCancelled:number;
   }
export class Offer{
    OfferId:number;
    OfferName:string;
    OfferDescription:string;
    LocationId:number;
    OfferCode:string;
    IsActive:boolean;
}
export class CheckOutViewModel{
    DeliveryAddressId : number;
    CartListItem: CheckOutCartItem[];
    UsePromotionCoupon:boolean;
}
export class CheckOutCartItem{
    ProductMappingId:number;
    OrderQuantity:number;
    ProductId:number;
    VendorId:number;
    ProductUnitId:number;
}
export class AutocompleteItem{
    Category:number;
    Product:number;
    SubCategory:number;
    Brand:number;
    SearchText:string;
}
export class ValidateCheckoutVM{
    addressList : AddressItem[];
    deliveryInfoDetails : VendorDeliveryInfoVM[];
    walletAmount :number;
}
export class AddressItem{
    AddressId : number;
    ContactName  : string;
    Street1  : string;
    Street2  : string;
    LandMark   : string;
    LocationId : number;
    LocationName : string;
    IsDefault  : boolean;
    Contact: string;
    Type:string;
}
export class DeliveryChargeVM{
    DeliveryChargeId:number;
    DeliveryChargeDescription:string;
    MinOrderAmount:number;
    MaxOrderAmount:number;
    DeliveryAmount:number;
}
export class VendorDeliveryInfoVM{
    VendorId:number;
    VendorName:string;
    DeliveryInfo:string;
    deliveryChargeList: DeliveryChargeVM[];
}
export class ProductFilterModel{
    PageNumber:number;
    LocationId:number[];
    CategoryId:number[];
    SubCategoryId:number[];
    BrandId:number[];
    keyword:string;
    ProductTypeId:number[];
    VendorId:number[];
    ProductId:number[];
}
export class DeliveryWithChargeViewModel{
    VendorId:number;
    VendorName:string;
    DeliveryChargeAmount:number;
    TotalAmount:number;
    DeliveryInfo:string;
    MyCarItemList:MyCartList[];
}

export class AboutViewModel{
    CompanyName:string;
    ContactNumber:string;
    Email:string;
    About:string;
    Rules:string;
    WebSite:string;
}
export class FilterTypeViewmodel{
    productTypeList :ProductTypelist[];
    brandList : BrandList [];
    categoryList : CategoryList[];
    vendorList : VendorList[];
}
export class VendorList{
    vendorId:number;
    vendorName :string;
}

export class WalletDetailsViewModel{
    WalletDescription : string;
    TransacrionDate: string;
    TrasactionAmount: string;
}
export class WalletViewModel
{
    walletBalance :string
    walletDetail:WalletDetailsViewModel[]
}


// WEBPACK FOOTER //
// ./src/pages/model/types.ts